import { getToken } from "@firebase/app-check";
import { appCheck } from "../services/firebase";
export default function axiosInterceptor(axiosInstance) {
  axiosInstance.interceptors.request.use(async (request) => {
    const userToken = localStorage.getItem("tk");
    const isLoggedIn = userToken ? true : false;

    request.headers = {
      "content-type": "application/json;charset=utf-8",
      "device_type": "ios-promise",
    };

    // Add Firebase AppCheck token to the request headers
    try {
      const appCheckToken = await getToken(appCheck);
      // console.log(appCheckToken)
      request.headers["X-Firebase-AppCheck"] = appCheckToken.token;
    } catch (error) {
      console.error("Error obtaining App Check token:", error); // Handle errors if token is not retrieved.
    }

    if (isLoggedIn) {
      request.headers["authorization"] = `Bearer ${userToken}`; // When the a user is logged in, set the authorization header to the existing headers, to avoid overwriting the entire request.headers object.
    }
    return request;
  });

  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    },
  );
}
